export default __webpack_public_path__ + "static/media/cloud-sun-rain.2b95ba37.svg";